<template>
	<div class="single_content">
		<v-breadcrumbs id="breadcrumbs" class="back">
			<v-icon slot="divider">chevron_right</v-icon>
			<v-breadcrumbs-item>
				<router-link :to="{ name: 'products', params: { super_family: decodeURIComponent($route.path.split('/')[2]) }}" class="back"> {{ routeName }} </router-link>
			</v-breadcrumbs-item>
			<v-breadcrumbs-item>
				{{data.label}}
			</v-breadcrumbs-item>
		</v-breadcrumbs>

		<v-loading loader='setSingleData' class="loader" v-if="$loading.isLoading('setSingleData')">
            <template slot='spinner'>
                <div class="loader">
                    <img src="../../../assets/img/grid_loader.svg"/>
                </div>
            </template>
        </v-loading>

		<div class="single"
			 v-scroll="{target: '#scroll-target', callback: this.onScroll}"
			 :class="{'fixed': scrollPosition > 90}"
			 v-if="!$loading.isLoading('setSingleData')">

			 <aside>
				 <div class="top">
					 <div class="border">
						 <more-actions :actions="actions"></more-actions>
					 </div>
					 <div @click="$eventHub.$emit('view-file', product.photo, 'avatar')" v-if="product.type == 'sidamo'" class="zoom">
						 <avatar :item="product" size="10rem" field="photo"></avatar>
					 </div>
					 <upload-avatar :defaultImg="require('../../../assets/img/defaultProduct.png')" :item="product" entities="products" field="photo" v-else></upload-avatar>
				 </div>

				 <div class="contain">
					 <div class="name">
						 <h2>{{data.label}}</h2>
					 </div>

					 <div class="name" v-if="data.supplier">
						 <h3>{{data.supplier.name}}</h3>
					 </div>

					 <div v-if="data.version">
						V{{data.version}}
					 </div>

					 <div v-if="data.category">
						 {{data.category.parent.parent.label}}
					 </div>

					 <div class="numbers">
						 <div @click.stop="$router.push({ name: 'product-comments' })">
							 <span>{{data.comments_count}}</span> {{data.comments_count | pluralize('Commentaire')}}
						 </div>

						 <div @click.stop="$router.push({ name: 'product-files' })">
							 <span>{{data.files_count}}</span> {{data.files_count | pluralize('Fichier')}}
						 </div>
					 </div>

					 <div class="about">
						 <div class="field mb-1" data-group="0">
							 <div class="label">Type</div>
							 <div class="value" v-if="data.type">
								 Produit {{$_.find(ProductTypes, p => p.value == data.type).label}}
							 </div>
						 </div>

						 <div class="field mb-1" data-group="0">
							 <div class="label">Projet</div>
							 <div class="value">
								 <router-link :to="{ name : 'single-project', params: {id: data.project.id }}" v-if="data.project">{{data.project.label}}</router-link>
								 <v-btn icon small @click="$eventHub.$emit('open-modal', UpdateProject)" class="edit" :disabled="$store.state.auth.user.level < 60"><v-icon>mode_edit</v-icon></v-btn>
							 </div>
						 </div>

						 <div class="field mb-1" data-group="0">
							 <div class="label">Fournisseur</div>
							 <div class="value">
								 <template v-if="data.supplier">{{data.supplier.name}}</template>
								 <v-btn icon small @click="$eventHub.$emit('open-modal', UpdateSupplier)" class="edit" :disabled="$store.state.auth.user.level < 60"><v-icon>mode_edit</v-icon></v-btn>
							 </div>
						 </div>

						 <div class="field mb-1" data-group="0">
 							<div class="label">Famille</div>
 							<div class="value">
 								{{getParentCategory}}
 							</div>
 						</div>

 						<div class="field mb-1" data-group="0">
 							<div class="label">Sous famille</div>
 							<div class="value">
 								{{getCategory}}
 							</div>
 						</div>

					 	<div class="field mb-1" data-group="0">
							<div class="label">Code article</div>
							<div class="value">
              					<single-field
									:model="data.code"
									ref="code"
									type="text"
									@validate="updateField('code', $event)"
									:hide_eye="true"
									:readonly="true">
								</single-field>
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Code ean</div>
							<div class="value">
              					<single-field
									:model="data.ean"
									ref="code"
									type="text"
									@validate="updateField('ean', $event)"
									:readonly="true"
									:hide_eye="true">
								</single-field>
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Date de modif.</div>
							<div class="value">
								{{moment(data.updated_at).format('DD/MM/YYYY')}}
							</div>
						</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Date de créa.</div>
							<div class="value">
								{{moment(data.created_at).format('DD/MM/YYYY')}}
							</div>
						</div>

          				<div class="field mb-1" data-group="0">
            				<div class="label">Lien externe</div>
        					<div class="value">
          						<single-field :model="data.external_link" ref="external_link" type="link" @validate="updateField('external_link', $event)" :hide_eye="true"></single-field>
        					</div>
          				</div>

						<div class="field mb-1" data-group="0">
							<div class="label">Gestionnaire</div>
							<div class="value">
								<template v-if="data.user">
									<avatar :item="data.user" size="4rem"></avatar>
									{{data.user ? data.user.first_name : ''}} {{data.user ? data.user.last_name :''}}
								</template>
								<v-btn icon small @click="$eventHub.$emit('open-modal', UpdateManager)" class="edit" :disabled="$store.state.auth.user.level < 60"><v-icon>mode_edit</v-icon></v-btn>
							</div>
						</div>

                	</div>
				</div>
			</aside>

				<div class="tab">
					<v-tabs slider-color="primary" :show-arrows="true">
						<v-tab ripple :to="{ name: 'product-data-sheet'}">Fiche technique</v-tab>
						<v-tab ripple :to="{ name: 'product-files' }">{{data.files_count | pluralize('Fichier')}} ({{data.files_count}})</v-tab>
						<v-tab ripple :to="{ name: 'product-comments' }">
							{{data.comments_count | pluralize('Commentaire')}}
							({{data.comments_count}})
						</v-tab>
						<v-tab ripple :to="{ name: 'product-requests' }" v-if="data.type == 'sidamo'">
							{{data.requests_count | pluralize('Demande')}}
							({{data.requests_count}})
						</v-tab>
						<v-tab ripple :to="{ name: 'product-tests' }" v-if="data.type == 'sidamo'">
							{{data.tests_count | pluralize('Contrôle')}}
							({{data.tests_count}})
						</v-tab>
						<v-tab ripple :to="{ name: 'product-components' }" v-if="data.type == 'sidamo'">Pièces détachées</v-tab>
						<v-tab ripple :to="{ name: 'product-accessories' }" v-if="data.type == 'sidamo'">Accessoires</v-tab>
						<v-tab ripple :to="{ name: 'product-consumables' }" v-if="data.type == 'sidamo'">Consommables</v-tab>
					</v-tabs>

					<div class="router_view">
						<router-view />
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	import UploadAvatar	 from '../../../components/avatar/UploadAvatar'
	import MoreActions	 from '../../../components/single/MoreActions'
	import Avatar 		 from '../../../components/avatar/Avatar'
	import {ProductTypes}from '../../../config/enum/ProductTypes'
	import SingleField	 from '../../../components/SingleField'
	import Delete 		 from './Delete'
	import UpdateManager from './UpdateManager'
	import ResyncProduct from './ResyncProduct'
	import LoadPDF 	     from './LoadPDF.vue'
	import moment		 from 'moment'
	import UpdateProject from './UpdateProject.vue'
	import UpdateSupplier from './UpdateSupplier.vue'
	import UpdateVersion from './UpdateVersion.vue'

	export default {
		components: { UploadAvatar, MoreActions, SingleField, Avatar},

		data() {
			return {
			    moment,
				product: {},
				scrollPosition: '',
				Delete,
				UpdateManager,
				ProductTypes,
				LoadPDF,
				UpdateProject,
				UpdateSupplier,
				UpdateVersion,

				actions: [
					{ text: 'Exporter', 	callback: () => this.export() },
					{ text: 'Supprimer',	callback: () => this.$eventHub.$emit('open-modal', Delete), level: 60 }
				]
			}
		},

		computed: {
			data() {
				return this.$store.state.single.data
			},

			getCategory() {
				return !!this.$store.state.single.data.category ? this.$store.state.single.data.category.label : '';
			},

			getParentCategory() {
				return !!this.$store.state.single.data.category ?
					this.$store.state.single.data.category.parent.label : '';
			},

			routeName() {
				let name = this.$route.path.split('/')
				return name[1] + ' ' + decodeURIComponent(name[2])
			}
		},

		methods: {
			userLoded() {
				return !!this.$store.state.single.data.user;
			},

			updateField(key, value, resource = 'products') {
				let model = {};
				model[key] = value;

				this.axios.put(`/api/${resource}/${this.$route.params.id}`, model)
					.then(response => {
						this.$store.dispatch('updateSingleData', { key, value })
					})
					.catch(error => {
						this.$refs[key].setError(error.response.data.errors[key][0])
					})
			},

			updateMeta(meta, value) {
				let model = { metas: [] }

				if (meta.options != undefined) {
					if (typeof value == 'number') {
						model.metas.push({ meta_id: meta.id, meta_value_id: [value] })
					} else {
						model.metas.push({ meta_id: meta.id, meta_value_id: value })
					}

				} else {
					model.metas.push({ meta_id: meta.id, value: value })
				}

				this.axios.put(`/api/projects/${this.$route.params.id}`, model)
					.then(response => {
						this.$store.dispatch('updateSingleMetaData', { meta, value })
					})
					.catch(error => {
						this.$refs[meta.slug].setError(error.response.data.errors[meta.slug][0])
					})
			},

			getDataFromApi(load = true) {
				load == false ? '' : this.$loading.startLoading('setSingleData')
				this.axios.get(`/api/products/${this.$route.params.id}?embed=comments,requests,supplier,user,category.parent.parent,fields,features,tests,project,files,accessories`)
					.then(response => {
						this.product = response.data
						if(this.product.fields && this.product.fields.length > 0){
							this.product.fields = this.$_.orderBy(this.product.fields, f => { return f.pivot.position })
						}
						this.$store.dispatch('setSingleData', { data: this.product })
                        if (this.product.type === 'sidamo') {
                            this.actions = [
                                { text: 'Resynchroniser',	callback: () => this.$eventHub.$emit('open-modal', ResyncProduct), level:60 },
                                { text: 'Changer la version',	callback: () => this.$eventHub.$emit('open-modal', UpdateVersion), level:60 },
                                { text: 'Exporter', 		callback: () => this.export() },
                                { text: 'Exporter le pdf', 	callback: () => this.$eventHub.$emit('open-modal', LoadPDF) },
                                { text: 'Supprimer',		callback: () => this.$eventHub.$emit('open-modal', Delete), level:60 }
                            ];
                        }
                        else {
                            this.actions = [
                                // { text: 'Exporter', 	callback: () => this.export() },
								// { text: 'Exporter le pdf', 	callback: () => this.$eventHub.$emit('open-modal', LoadPDF) },
                                { text: 'Supprimer',	callback: () => this.$eventHub.$emit('open-modal', Delete), level:60 },
                            ];
                        }
						this.$loading.endLoading('setSingleData')
					})

			},

			onScroll(e) {
				this.scrollPosition = e.target.scrollTop
			},

			export() {
				this.axios.post(`/api/products/${this.$route.params.id}/export`, { })
					.then(res => {
						let a 	= document.createElement('A')
						a.href	= res.data
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					})
			},
		},

		watch: {
			$route(to, from) {
				this.getDataFromApi(false);
			}
		},

		created() {
			this.$eventHub.$on('reload-single', () => {
				this.getDataFromApi();
			})
		},

		mounted() {
			this.getDataFromApi();
		}
	}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/main'

    aside {
		position: relative

    	div.numbers {
      		div {
        		&:nth-of-type(-n+2) {
          			border-right: 1px solid $border-light-color
        		}
      		}
    	}

    	div.about {
      		flex-grow: 1

      		.avatar {
        		margin-right: 1rem
      		}
    	}
	}

	div.tabs {
		margin-bottom: 3.2rem
	}
</style>



// WEBPACK FOOTER //
// src/views/products/single/Single.vue